import { PartSearchResponse, QuoteSelectSuppliersDataResponse } from "@/main/models/response";
import { useCreateOrderContext } from "@/main/screens/order/createorder/context";
import { PartTypeEnum } from "@/main/services/enum/PartTypeEnum";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { useUserReducer } from "@/main/store/user";

import CountControl from "../../countControl/countControl";
import FavoriteButton from "../../favoriteButton/favoriteButton";
import KOGButtonsTriggerPaintProject from "../../kogButtonsTriggerPaintProject/kogbuttonsTriggerPaintProject";
import StarRatingPartially from "../../starRating/starRatingPartially";
import RowCardPaintProject from "./rowCardPaintProject/rowCardPaintProject";
import { IPartInCart } from "../cardShopping";
import * as S from "./styles";

export interface ICardPaintProjectProps {
	selectSupplier: QuoteSelectSuppliersDataResponse;
	partInCart: IPartInCart;
}

const RenderPartTitle = ({ selectSupplier }: Pick<ICardPaintProjectProps, "selectSupplier">) => {
	const renderPartTypeAndPartBrand = () => {
		if (!selectSupplier.idPartType || !selectSupplier.partType) {
			return "";
		}

		if (selectSupplier.idPartType !== PartTypeEnum.OEM) {
			const partBrandDescription = selectSupplier.partBrandDescription
				? `(${selectSupplier.partBrandDescription})`
				: "";
			return ` - ${selectSupplier.partType} ${partBrandDescription}`;
		}

		return ` - ${selectSupplier.partType}`;
	};
	const renderPartTitle = renderPartTypeAndPartBrand();

	return (
		<S.AreaTextCode title={selectSupplier.partCode + renderPartTitle}>
			<S.TextPartCode>{selectSupplier.partCode}</S.TextPartCode>
			<S.TextPartType>{renderPartTitle}</S.TextPartType>
		</S.AreaTextCode>
	);
};

function CardPaintProject({ selectSupplier, partInCart }: ICardPaintProjectProps) {
	const { guidQuote, partGuid } = useCreateOrderContext();

	const renderDeliveryTime = `${selectSupplier.deliveryDays} ${getTranslateByKey("information.deliveryDays")}`;
	const userReducer = useUserReducer();

	function mapSelectSupplierToPart(): PartSearchResponse {
		return {
			guid: partGuid,
			isPaintType: selectSupplier.idPartType === PartTypeEnum.Paint,
			partCategoryName: selectSupplier.partCategoryName,
			partName: selectSupplier.partTitle,
			partSubCategoryName: selectSupplier.partSubCategoryName,
			guidPosition: "",
			position: "",
		};
	}

	const isCollumnGrid = userReducer.userPreference.preferences.isViewCard;

	if (!isCollumnGrid) {
		return <RowCardPaintProject selectSupplier={selectSupplier} partInCart={partInCart} />;
	}
	return (
		<S.Container $isRecommended={selectSupplier.isRecomendedSupplier}>
			<S.Header>
				<S.TextSupplier title={selectSupplier.supplier}>{selectSupplier.supplier}</S.TextSupplier>
				<S.AreaFavorite>
					<FavoriteButton notClickable isFavorite={selectSupplier.isFavoriteSupplier} onToggleFavorite={() => {}} />
				</S.AreaFavorite>
			</S.Header>

			<S.Content>
				<S.AreaImage>
					<img src={selectSupplier.image} alt="" />
				</S.AreaImage>
				<S.AreaDescription>
					<RenderPartTitle selectSupplier={selectSupplier} />
					<S.TextPartTitle title={selectSupplier.partTitle}>{selectSupplier.partTitle}</S.TextPartTitle>
					<S.TextDeliveryTime title={renderDeliveryTime}>{renderDeliveryTime}</S.TextDeliveryTime>
				</S.AreaDescription>
				<S.AreaEvaluation>
					<StarRatingPartially rating={!isNullUndefined(selectSupplier.score) ? selectSupplier.score : 0} />
				</S.AreaEvaluation>
				<S.AreaButtons>
					{partInCart ? (
						<CountControl removeArrow initialCount={partInCart.quantity} maxCount={partInCart.stock} />
					) : (
						<KOGButtonsTriggerPaintProject
							guidQuote={String(guidQuote)}
							selectSupplier={selectSupplier}
							part={mapSelectSupplierToPart()}
						/>
					)}
				</S.AreaButtons>
			</S.Content>
		</S.Container>
	);
}

export default CardPaintProject;
